import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Stack, Typography } from "@mui/material";

import { CommonDialog } from "@/components/common/CommonDialog";
import { PrimaryButton } from "@/components/common";

import { formatPriceBrl } from "../utils/addressHelpers";
import { marketplaceTypography as mt } from "../constants/marketplaceTypography";
import type { WooOrder } from "../types";

interface WooPaymentSuccessDialogProps {
  open: boolean;
  order: WooOrder | null;
  onClose: () => void;
  onViewOrders: () => void;
}

/** Feedback de pagamento confirmado. */
export function WooPaymentSuccessDialog({
  open,
  order,
  onClose,
  onViewOrders,
}: WooPaymentSuccessDialogProps) {
  if (!order) return null;

  const footer = (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="flex-end">
      <PrimaryButton
        width={{ xs: "100%", sm: "fit-content" }}
        height="44px"
        onClick={() => {
          onClose();
          onViewOrders();
        }}
      >
        Ver meus pedidos
      </PrimaryButton>
    </Stack>
  );

  return (
    <CommonDialog
      isOpen={open}
      handleClose={onClose}
      maxWidth="xs"
      sheetTitle="Pagamento confirmado!"
      sheetSubtitle={`Pedido #${order.id} · ${formatPriceBrl(order.total)} · ${order.storeName}`}
      footer={footer}
    >
      <Stack spacing={1.5} alignItems="center" sx={{ py: 2, textAlign: "center" }}>
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 56 }} />
        <Typography sx={{ ...mt.body, color: "text.secondary" }}>
          Seu pagamento foi confirmado com sucesso.
        </Typography>
      </Stack>
    </CommonDialog>
  );
}
